import queryString from 'querystringify';

export const getQueryString = (search?: string) => (search ? queryString.parse(search) : undefined);

export const createQueryString = (query: any) => queryString.stringify(query);

// Function to filter querystrings to allowed list;

export const filterQueryString = (queryStringObj: {}, allowed: any[]) => {
  const filtered = Object.entries(queryStringObj).filter(([key, value]) => allowed.includes(key));
  // convert array of arrays to object
  return filtered.reduce((obj, [key, value]) => {
    if (value) {
      obj[key] = value;
    }
    return obj;
  }, {});
};
//
